import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { Collapse, Divider, Row, Tooltip } from "antd";
import { useOfferContext } from "../context/OfferContext";
import { useAppDispatch, useAppSelector } from "../../..";
import { offeringActions, fetchServiceRateVersions } from "../../../store/slices/offering/offering";
import { fetchTax } from "../../../store/slices/taxTs";
import { checkIsLoading, toHttpFormatStartOfDay } from "../../../lib/utils";
import HistoryAndPropertyModal from "../../../components/HistoryAndPropertyModal/HistoryAndPropertyModal";
import { MENU_ADMIN_OFFERING_WRITE } from "../../../lib/const/permissions";
import { hasAccess } from "../../../components/RolesModule/hasAccess";
import { ServiceRateView } from "../../../components/common/ServiceRate/ServiceRateView/ServiceRateView";
import { ReactComponent as PlusIcon } from "../../../img/plus.svg";
import "./TarificationParamsContainer.less";

/* ------------------------------------------------------ Начало компонента ------------------------------------------------------ */

export const TarificationParamsContainer = () => {
  const { activeOfferVersion, priceCreationAllowed } = useOfferContext();
  const dispatch = useAppDispatch();
  const history = useHistory();
  const location = useLocation();

  const { offer, serviceRates, serviceRatesLoading } = useAppSelector((state) => state.offering);
  const { aggregationRules, aggregationRulesLoading } = useAppSelector(
    (state) => state.aggregationRules
  );

  // Исходная загрузка ставки налога для отображения в таблице цен
  useEffect(() => {
    if (offer?.serviceTypeId && offer.fromDate) {
      dispatch(
        fetchTax({
          serviceTypeId: offer.serviceTypeId,
          amount: 1, // Нужна только ставка налога, поэтому передается 1
          amountType: "NET",
          onDate: offer.fromDate,
        })
      );
    }
  }, [offer]);

  const offerOnDate = new URLSearchParams(location.search).get("onDate")?.replace(" ", "+");

  const [historyModalVisible, setHistoryModalVisible] = useState(false);
  const [objectId, setObjectId] = useState<number | null>(null);

  const showHistoryModal = (rateId: number) => {
    setHistoryModalVisible(true);
    setObjectId(rateId || null);
  };

  const [collapseKeys, setCollapseKeys] = useState<string | string[]>([]);

  // Открытие раздела, в случае наличия serviceRates
  useEffect(() => {
    if (serviceRates.length) {
      setCollapseKeys(["1"]);
    } else {
      setCollapseKeys([]);
    }
  }, [serviceRates]);

  const onClickVersionIcon = (rateId: number, isVersionsOpen: boolean) => {
    if (isVersionsOpen) {
      dispatch(offeringActions.cleanServiceRateVersions());
    } else {
      dispatch(fetchServiceRateVersions(rateId));
    }
  };

  return (
    <div className="tariffication-params-container">
      <Divider className="tariffication-params-container__upperDivider" />
      <Collapse
        activeKey={collapseKeys}
        bordered={false}
        onChange={(keys) => {
          setCollapseKeys(keys);
        }}
      >
        <Collapse.Panel
          key="1"
          header={
            <Row justify="space-between" className="tariffication-params-container__pageTitle">
              <h3 id="offering-tariffication-title">Тарификация</h3>
              {priceCreationAllowed && (
                <Tooltip title="Создать цену">
                  <PlusIcon
                    onClick={() => {
                      if (activeOfferVersion?.id && offerOnDate) {
                        history.push(
                          `/offer/${activeOfferVersion.id}/price/create?onDate=${offerOnDate}`
                        );
                      }
                    }}
                    className="serviceRate-edit__addButton"
                  />
                </Tooltip>
              )}
            </Row>
          }
        >
          <Divider style={{ margin: 0 }} />
          <ServiceRateView
            serviceRates={serviceRates}
            aggregationRules={aggregationRules}
            showHistoryModal={showHistoryModal}
            onClickVersionIcon={onClickVersionIcon}
            isLoading={checkIsLoading(serviceRatesLoading, aggregationRulesLoading)}
          />
        </Collapse.Panel>
      </Collapse>
      <HistoryAndPropertyModal
        objectTypeSysname="service_rate"
        objectId={objectId}
        handleHideModal={() => setHistoryModalVisible(false)}
        visibleModal={historyModalVisible}
        hasAccessToEdit={hasAccess(MENU_ADMIN_OFFERING_WRITE)}
      />
    </div>
  );
};
